import jwtDecode from "jwt-decode";
import { read, remove, store } from "./LocalStorage";
import { readToken } from "./Token";
import { push } from "./History";

export const analyzeToken = (token) => {
  if (token) {
    let decode = jwtDecode(token);
    if (decode.StypeU === "4" && decode.StypeP === "7") gsaat(decode);
    else guat(decode);
  } else {
    //! ** I N V A L I D  T O K E N **
    const lockStatus = read("isLocked");
    localStorage.clear();
    store("isLocked", lockStatus);
    push(`/`);
    window.location.reload();
    //! ** I N V A L I D  T O K E N **
  }
};

const gsaat = (decode) => {
  // get super admin analyze token
  store("userAKey", decode.sub);
  store("groupAKey", decode.actort);
  store("StypeUA", decode.StypeU);
  store("UserCA", decode.UserC);
  store("StypePA", decode.StypeP);
  store(
    "companyAName",
    decode.given_name !== undefined ? decode.given_name : null,
  );
  store(
    "groupAName",
    decode.family_name !== undefined ? decode.family_name : null,
  );
  store(
    "FormCustomerSupport",
    decode.Fcst !== undefined ? getRules(decode.Fcst) : null,
  );
  store(
    "FormDefaultCredit",
    decode.Fdct !== undefined ? getRules(decode.Fdct) : null,
  );
  store(
    "FormDiscount",
    decode.Fdis !== undefined ? getRules(decode.Fdis) : null,
  );
  store(
    "FormDefaultPanel",
    decode.Fdpl !== undefined ? getRules(decode.Fdpl) : null,
  );
  store("Financial", decode.Fina !== undefined ? getRules(decode.Fina) : null);
  store(
    "FormIncTime",
    decode.Finc !== undefined ? getRules(decode.Finc) : null,
  );
  store(
    "FormManualCredit",
    decode.Fmct !== undefined ? getRules(decode.Fmct) : null,
  );
  store("FormPeriod", decode.Fper !== undefined ? getRules(decode.Fper) : null);
  store("Notice", decode.Noti !== undefined ? getRules(decode.Noti) : null);
  store(
    "FormPriceSuperAdmin",
    decode.Prsu !== undefined ? getRules(decode.Prsu) : null,
  );
  store("Statistics", decode.Stat !== undefined ? getRules(decode.Stat) : null);
  store("Support", decode.Supp !== undefined ? getRules(decode.Supp) : null);
};

const guat = (decode) => {
  // get user analyze token
  store("userKey", decode.sub);
  store("groupKey", decode.actort);
  store(
    "SpacerRules",
    decode.qerh !== undefined ? getRules(decode.qerh) : null,
  );
  store(
    "ShisheRules",
    decode.qdzq !== undefined ? getRules(decode.qdzq) : null,
  );
  store(
    "mahsoleShisheGroupRules",
    decode.xrhi !== undefined ? getRules(decode.xrhi) : null,
  );
  store(
    "mahsoleShisheRules",
    decode.tflm !== undefined ? getRules(decode.tflm) : null,
  );
  store("toriRules", decode.tzyv !== undefined ? getRules(decode.tzyv) : null);
  store("rokubRules", decode.pact !== undefined ? getRules(decode.pact) : null);
  store(
    "fomMasticRules",
    decode.fmjk !== undefined ? getRules(decode.fmjk) : null,
  );
  store(
    "addSeriProfileRules",
    decode.ahde !== undefined ? getRules(decode.ahde) : null,
  );
  store(
    "yaraghRules",
    decode.fija !== undefined ? getRules(decode.fija) : null,
  );
  store(
    "lasticRules",
    decode.flia !== undefined ? getRules(decode.flia) : null,
  );
  store(
    "companyName",
    decode.given_name !== undefined ? decode.given_name : null,
  );
  store(
    "groupName",
    decode.family_name !== undefined ? decode.family_name : null,
  );
  store(
    "templateRules",
    decode.atun !== undefined ? getRules(decode.atun) : null,
  );
  store(
    "groupCustomerRules",
    decode.gtyj !== undefined ? getRules(decode.gtyj) : null,
  );
  store(
    "khadamatRules",
    decode.Khmt !== undefined ? getRules(decode.Khmt) : null,
  );
  store(
    "typeColorRules",
    decode.juuz !== undefined ? getRules(decode.juuz) : null,
  );
  store("StypeU", decode.StypeU); // Admin = 1, Agent = 2, Guest = 3,AdminAccounting = 4, SuperVisor = 5
  store("UserC", decode.UserC); // 1  0
  store("StypeP", decode.StypeP); //  AdminPanel = 1,پانل ادمین GuestPanel = 2,پانل مهمان Shop = 3,فروشگاهی ShopAndGlassCut = 4,فروشگاهی با گزارش شیشه Workshop = 5,کارگاهی Store = 6 انبارداری
  store(
    "settingFactorRules",
    decode.Stgn !== undefined ? getRules(decode.Stgn, "7721") : null,
  );
  store(
    "settingConstructRules",
    decode.Stgn !== undefined ? getRules(decode.Stgn, "3918") : null,
  );
  store(
    "settingDesignerRules",
    decode.Stgn !== undefined ? getRules(decode.Stgn, "2349") : null,
  );
  store(
    "constructGlass",
    decode.Wosa !== undefined ? getRules(decode.Wosa, "3967") : null,
  );
  store(
    "constructCutList",
    decode.Wosa !== undefined ? getRules(decode.Wosa, "3990") : null,
  );
  store(
    "settingShopTemplate",
    decode.Fssp !== undefined ? getRules(decode.Fssp, "3220") : null,
  );
  store(
    "settingShopGlass",
    decode.Fssp !== undefined ? getRules(decode.Fssp, "4220") : null,
  );
  store(
    "settingShopProject",
    decode.Fssp !== undefined ? getRules(decode.Fssp, "5220") : null,
  );
  store(
    "statisticsRules",
    decode.Stat !== undefined ? getRules(decode.Stat) : null,
  );
  store(
    "contractRules",
    decode.Cont !== undefined ? getRules(decode.Cont) : null,
  );
};

const getRules = (str, param = "") => {
  let codes = str.split("-");
  let accessRegister = false;
  let accessDelete = false;
  let accessPrice2 = false;
  let accessShow = false;
  let accessUpdate = false;
  codes.forEach((item) => {
    switch (item) {
      case "1921":
        accessRegister = true;
        break;
      case "1696":
        accessUpdate = true;
        break;
      case "6770":
        accessDelete = true;
        break;
      case "6696":
        accessPrice2 = true;
        break;
      case "9817":
        accessShow = true;
        break;
      case param:
        accessRegister = accessShow = true;
        break;
    }
  });
  if (accessShow === false || accessShow === null) return null;
  return {
    accessRegister: accessRegister,
    accessUpdate: accessUpdate,
    accessDelete: accessDelete,
    accessPrice2: accessPrice2,
    accessShow: accessShow,
  };
};

export const getIsPanelLock = () => {
  if (!isSuperAdmin()) {
    const localToken = readToken();
    const token = jwtDecode(localToken);
    return token.Lcpa === "19210114";
  } else {
    if (read("StypeSwAllow")) {
      const pathSplit = window.location.pathname.split("/");
      if (pathSplit[1] !== "dashboard") {
        push("/admin");
      } else {
        return false;
      }
    } else {
      push("/admin");
    }
  }
};

export const isSuperAdmin = () => {
  return read("StypeUA") === "4" && read("StypePA") === "7";
};

export const createFakeStorage = (groupKey, userKey) => {
  const fuac = {
    accessRegister: true,
    accessUpdate: true,
    accessDelete: true,
    accessPrice2: true,
    accessShow: true,
  };
  store("userKey", userKey);
  store("groupKey", groupKey);
  store("StypeSwAllow", true);
  store("StypeU", "1");
  store("UserC", "-");
  store("StypeP", "1");
  // store("companyName", companyName);
  // store("groupName", groupName);
  store("SpacerRules", fuac);
  store("ShisheRules", fuac);
  store("mahsoleShisheGroupRules", fuac);
  store("mahsoleShisheRules", fuac);
  store("toriRules", fuac);
  store("rokubRules", fuac);
  store("fomMasticRules", fuac);
  store("addSeriProfileRules", fuac);
  store("yaraghRules", fuac);
  store("lasticRules", fuac);
  store("templateRules", fuac);
  store("groupCustomerRules", fuac);
  store("khadamatRules", fuac);
  store("typeColorRules", fuac);
  store("settingFactorRules", fuac);
  store("settingConstructRules", fuac);
  store("settingDesignerRules", fuac);
  store("constructGlass", fuac);
  store("constructCutList", fuac);
  store("statisticsRules", fuac);
  store("contractRules", fuac);
};

export const clearFakeStorage = () => {
  remove("userKey");
  remove("groupKey");
  remove("StypeSwAllow");
  remove("StypeU");
  remove("UserC");
  remove("StypeP");
  remove("companyName");
  remove("groupName");
  remove("SpacerRules");
  remove("ShisheRules");
  remove("mahsoleShisheGroupRules");
  remove("mahsoleShisheRules");
  remove("toriRules");
  remove("rokubRules");
  remove("fomMasticRules");
  remove("addSeriProfileRules");
  remove("yaraghRules");
  remove("lasticRules");
  remove("templateRules");
  remove("groupCustomerRules");
  remove("khadamatRules");
  remove("typeColorRules");
  remove("settingFactorRules");
  remove("settingConstructRules");
  remove("settingDesignerRules");
  remove("constructGlass");
  remove("constructCutList");
  remove("statisticsRules");
  remove("contractRules");
};
